export default __webpack_public_path__ + "static/media/sanmat1.09c2f563.jpg";